/**
 * Supported payment type
 * @type {{PAYMENT: string, AGREEMENT: string}}
 */
export const PaymentType = {
    PAYMENT: 'PAYMENT',
    AGREEMENT: 'AGREEMENT'
}